<script>
import Layout from "../../layouts/main.vue";
import Heading from "../../layouts/heading.vue";
import FormBuilder from "../../layouts/FormBuilder.vue";
import { schema, default_days } from "./data";
import api from "../../../api";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';

export default {
  props: {
    category: {},
  },
  components: { 
    FormBuilder, 
    Layout,
     Heading
      },
  data() {
    return {
      page: schema,
      default_days: default_days,
      currentTopicActiveStatus: false,
      location_list: [],
      topbar: {},
      selectedLocation: {},
      selectedGroup: '',
      selectedSubgroup: '',
      member_locations: [],
      member_group: '',
      member_subgroup: ''
      
    };
  },
  methods: {
    create() {
      if(this.selectedTab == 'Team') {
        if(this.selectedGroup) {
        // if(this.selectedLocation.id) {
          var val = this.page.tabs.filter(tab => tab.name == this.selectedTab)[0].formData;
          var data = {
            uuid: uuidv4(),
            url: this.currentPractice.additionalProp1.url,
            active: true,
            title: val.name,
            picture: '',
            excerpt: 'Text here',
            description: '',
            deleted: false,          
            creationDate: new Date().toISOString(),
            lastModifiedDate: new Date().toISOString(),
            categoryId: this.category.id,
            cmsId: this.currentCms.id,
            pcnId: this.currentPracticeData.pcnId,
            additionalProp1: {
              group: this.selectedGroup.id,
              subgroup: this.selectedSubgroup ? this.selectedSubgroup.id : '',
              role: '',
              qualifications: '',
              gender: '',
              dynamoId: this.currentPractice.additionalProp1.dynamo,   
              availability: {
                locations: []
              }
            }
          };

          api.post('/api/categories/'+this.category.id+'/pages', data)
          .then((response) => {
            this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.unshift(response.data); 
            Swal.fire("Topic Added!", "Topic Added Successfully!", "success");
          }, (error) => {
            console.log(error);
          });
        }
        else {
            Swal.fire("No Group Selected!", "Please Select and try-again!", "warning");
        }
      }
      else if(this.selectedTab == 'Groups') {
        // var options = this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.groups.options; 
        var val2 = this.page.tabs.filter(tab => tab.name == this.selectedTab)[0].formData;
        var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

        var groups = this.category.additionalProp1.groups;
        if(!Array.isArray(groups)) {
          groups = [];
        }

        groups.unshift(
          {
            id: uuidv4(),
            title: val2.name,
            active: true,
            subgroups: []
          }
        )

        let where = {
          name: {
            like: 'Practice Team',
            options: "i"
          }
        };

        var data2 = {
          additionalProp1: {
            description: {
              text: this.category.additionalProp1.description ? this.category.additionalProp1.description.text : '',
            },
            icon: this.category.additionalProp1.icon,
            link: this.category.additionalProp1.link,
            groups: groups,
            // subgroups: this.category.additionalProp1.subgroups,
            related_information: updated_options
          },
        };

        api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, data2)
        .then(() => {
          this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options = groups;
          Swal.fire("Group Added!", "Group Added Successfully!", "success");

          // this.category.additionalProp1.groups = options;

        }, (error) => {
          console.log(error);
        });
      }
    },
    deleted() {
      var self = this;
      if(this.selectedTab == 'Team') {
        Swal.fire({
        title: `Are you sure you want to delete ${self.selectedItem.title}?`,
        text: "You won't be able to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
        }).then(result => {
          if (result.value) {
            api.delete('/api/pages/'+this.selectedItem.id)
            .then(() => {
              Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
              this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options
              .splice(
                this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.findIndex(function(i){
                return i.id === self.selectedItem.id;
              }), 1);
            }, (error) => {
              console.log(error);
            });
          }
        });
      }
      else if (this.selectedTab == 'Groups') {
        Swal.fire({
        title: `Are you sure you want to delete ${self.selectedItem.title}?`,
        text: "You won't be able to delete this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!"
        }).then(result => {
          if (result.value) {
            // var val2 = this.page.tabs.filter(tab => tab.name == this.selectedTab)[0].formData;
            var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

            var groups = this.page.tabs.filter(tab => tab.name == "Groups")[0].side_panel.groups.options;
            // if(!Array.isArray(groups) || !groups[0].id) {
            //   groups = [];
            // }

            groups = groups.filter(x => x.id != self.selectedItem.id)
            // groups.push(
            //   {
            //     id: uuidv4(),
            //     title: val2.name,
            //     active: true,
            //     subgroups: []
            //   }
            // )

            let where = {
              name: {
                like: 'Practice Team',
                options: "i"
              }
            };

            var data2 = {
              additionalProp1: {
                description: {
                  text: this.category.additionalProp1.description ? this.category.additionalProp1.description.text : '',
                },
                icon: this.category.additionalProp1.icon,
                link: this.category.additionalProp1.link,
                groups: groups,
                // subgroups: this.category.additionalProp1.subgroups,
                related_information: updated_options
              },
            };

            api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, data2)
            .then(() => {
              Swal.fire("Group Deleted!", "Group Deleted Successfully!", "warning");
              this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options
              .splice(
                this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.findIndex(function(i){
                return i.id === self.selectedItem.id;
              }), 1);
              // this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options = groups;
              // this.category.additionalProp1.groups = options;

            }, (error) => {
              console.log(error);
            });
            // api.delete('/api/pages/'+this.selectedItem.id)
            // .then(() => {
            //   Swal.fire("Topic Deleted!", "Topic Deleted Successfully!", "warning");
            //   this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options
            //   .splice(
            //     this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.findIndex(function(i){
            //     return i.id === self.selectedItem.id;
            //   }), 1);
            // }, (error) => {
            //   console.log(error);
            // });
          }
        });
      }


    },
    selectedTabFn(val) {
      this.selectedTab = val;
      this.topbar = this.page.tabs.filter(tab => tab.name == val)[0];
    },
    selectedItemFn(val) {
      this.selectedItem = val;
      this.currentTopicActiveStatus = val.active;
    },
    submit(val, side_panel_val) {
      if(this.selectedTab == 'Team'){
        console.log(side_panel_val)

        var locationsArr = [];

        if(this.selectedItem.additionalProp1.availability) {

          locationsArr = this.selectedItem.additionalProp1.availability.locations;

          if(!locationsArr || locationsArr.length) {
            locationsArr = [];
            for(const item of this.member_locations) {
              locationsArr.push({
                id: item.id,
                status: true,
                days: default_days
              });
            }
          }
          else {
            for(const loc of this.member_locations) {
              locationsArr = this.selectedItem.additionalProp1.availability.locations.filter(x => x.id == loc.id)
            }
            for(const loc of this.member_locations) {
              if(locationsArr.findIndex(x => x.id == loc.id) == -1) {
                locationsArr.push({
                  id: loc.id,
                  status: true,
                  days: default_days
                });
              }
            }
          }
        }
        else {
          for(const item of this.member_locations) {
            locationsArr.push({
              id: item.id,
              status: true,
              days: default_days
            });
          }
        }

        var data_team = {
          title: val.name,
          description: val.description,
          picture: '',
          // picture: val.profile,
          active: this.currentTopicActiveStatus,
          additionalProp1: {
            group: this.category.additionalProp1.groups.filter(x => x.title == this.member_group)[0].id,
            subgroup: this.member_subgroup && this.category.additionalProp1.groups.filter(x => x.title == this.member_group)[0].subgroups.filter(y => y.title == this.member_subgroup).length ? this.category.additionalProp1.groups.filter(x => x.title == this.member_group)[0].subgroups.filter(y => y.title == this.member_subgroup)[0].id : '',
            // group: this.member_group ? this.member_group : this.selectedItem.additionalProp1.group,
            // subgroup: this.member_subgroup ? this.member_subgroup : this.selectedItem.additionalProp1.subgroup,
            role: val.role,
            qualifications: val.qualifications,
            gender: val.gender,
            dynamoId: this.currentPractice.additionalProp1.dynamo,      
            availability: {
              locations: locationsArr
            }
          }
        };

        api.patch('/api/pages/'+val.id, data_team)
        .then(() => {
            this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.filter(l => l.id == val.id)[0].title = val.name;         
            this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.filter(l => l.id == val.id)[0].description = val.description 
            // this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.filter(l => l.id == val.id)[0].profile = val.picture 
            this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.filter(l => l.id == val.id)[0].active = this.currentTopicActiveStatus 
            this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.filter(l => l.id == val.id)[0].additionalProp1 = data_team.additionalProp1 
            // if(data_team.additionalProp1.group != this.selectedGroup || data_team.additionalProp1.subgroup != this.selectedSubgroup) {
            //   this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options = this.page.tabs.filter(tab => tab.name == 'Team')[0].side_panel.members.options.filter(x => x.id != val.id) 
            // }
            Swal.fire("Member Updated!", "Member Updated Successfully!", "success");
        }, (error) => {
          console.log(error);
        });
      }
      if(this.selectedTab == 'Description' || this.selectedTab == ''){

        var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

        let where = {
          name: {
            like: 'Practice Team',
            options: "i"
          }
        };

        var content_data = {
          additionalProp1: {
            description: {
              text: val.description,
            },
            icon: this.category.additionalProp1.icon,
            link: this.category.additionalProp1.link,
            related_information: updated_options,
            groups: this.category.additionalProp1.groups,
            subgroups: this.category.additionalProp1.subgroups
          },
        };

        api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, content_data)
        .then(() => {
          this.category.additionalProp1 = content_data.additionalProp1;
          Swal.fire("Category Updated!", "Category Updated Successfully!", "success");

        }, (error) => {
          console.log(error);
        });
      }
      else if(this.selectedTab == 'Groups'){

        var updated_options2 = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

        var groups = this.page.tabs.filter(tab => tab.name == "Groups")[0].side_panel.groups.options;

        groups.filter(x => x.id == val.id)[0].title = val.name;
        groups.filter(x => x.id == val.id)[0].subgroups = val.subgroups;

        let where = {
          name: {
            like: 'Practice Team',
            options: "i"
          }
        };

        var data2 = {
          additionalProp1: {
            description: {
              text: this.category.additionalProp1.description ? this.category.additionalProp1.description.text : '',
            },
            icon: this.category.additionalProp1.icon,
            link: this.category.additionalProp1.link,
            groups: groups,
            related_information: updated_options2
          },
        };

        api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, data2)
        .then(() => {
          let item = this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.filter(l => l.id == this.selectedItem.id)[0];
          item = val;
          this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.filter(l => l.id == this.selectedItem.id)[0] = item;
          Swal.fire("Group Status Updated!", "Group Status Updated Successfully!", "success");

        }, (error) => {
          console.log(error);
        });
      }
    },
    activateToggle() {
      if(this.selectedTab == 'Team') {
        this.currentTopicActiveStatus = !this.currentTopicActiveStatus;
        var data = {
          active: this.currentTopicActiveStatus
        };
        api.patch('/api/pages/'+this.selectedItem.id, data)
        .then(() => {

            let item = this.page.tabs[1].side_panel.members.options.filter(l => l.id == this.selectedItem.id)[0];
            item.active = this.currentTopicActiveStatus;
            this.page.tabs[1].side_panel.members.options.filter(l => l.id == this.selectedItem.id)[0] = item;
            this.$store.commit('updateOldFormData', item)
            this.$store.commit('updateCurrentFormData', item)
            Swal.fire("Topic Status Updated!", "Topic Status Updated Successfully!", "success");

        }, (error) => {
          console.log(error);
        });
      }
      else if(this.selectedTab == 'Groups') {
        this.currentTopicActiveStatus = !this.currentTopicActiveStatus;

        var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

        var groups = this.page.tabs.filter(tab => tab.name == "Groups")[0].side_panel.groups.options;
        let objIndex = groups.findIndex((obj => obj.id == this.selectedItem.id));
        groups[objIndex].active = this.currentTopicActiveStatus

        let where = {
          name: {
            like: 'Practice Team',
            options: "i"
          }
        };

        var data2 = {
          additionalProp1: {
            description: {
              text: this.category.additionalProp1.description ? this.category.additionalProp1.description.text : '',
            },
            icon: this.category.additionalProp1.icon,
            link: this.category.additionalProp1.link,
            groups: groups,
            related_information: updated_options
          },
        };

        api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, data2)
        .then(() => {
          let item = this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.filter(l => l.id == this.selectedItem.id)[0];
          item.active = this.currentTopicActiveStatus;
          this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.filter(l => l.id == this.selectedItem.id)[0] = item;
          this.$store.commit('updateOldFormData', item)
          this.$store.commit('updateCurrentFormData', item)
          Swal.fire("Group Status Updated!", "Group Status Updated Successfully!", "success");

        }, (error) => {
          console.log(error);
        });
      }
    },
    selectedLocationFn(val) {
      this.selectedLocation = val;
    },
    selectedGroupFn(val) {
      this.selectedGroup = val;
    },
    selectedSubgroupFn(val) {
      this.selectedSubgroup = val;
    },
    getLocations() {
      api.get(`/api/cms/${this.currentCms.id}/categories`)
      .then((response) => {
        var locationCat = response.data.filter(x => x.name == 'Locations')[0];
          api.get(`/api/categories/${locationCat.id}/pages`)
          .then((response) => {
            this.location_list = response.data;
            this.page.tabs.filter(tab => tab.name == 'Regular Hours')[0].side_panel.location.options = response.data;          
            this.page.tabs.filter(tab => tab.name == 'Holiday Hours')[0].side_panel.location.options = response.data;          
          }, (error) => {
            console.log(error);
          });
      }, (error) => {
        console.log(error);
      });
    },
    updateGroupFn(val) {
      this.$emit('add-group', val);
      var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

      var groups = this.category.additionalProp1.groups;
      if(!Array.isArray(groups)) {
        groups = [
          {
            id: uuidv4(),
            name: '',
            subgroups: []
          }
        ];
      }

      groups.push()

      let where = {
        name: {
          like: 'Practice Team',
          options: "i"
        }
      };

      var data = {
        additionalProp1: {
          description: {
            text: this.category.additionalProp1.description ? this.category.additionalProp1.description.text : '',
          },
          icon: this.category.additionalProp1.icon,
          link: this.category.additionalProp1.link,
          groups: groups,
          related_information: updated_options
        },
      };

      api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, data)
      .then(() => {
        // this.category.additionalProp1.groups = options;

      }, (error) => {
        console.log(error);
      });

    },
    removeSubGroupFn(val) {
      console.log(val);
      var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

      var groups = this.category.additionalProp1.groups;

      let subgroups = groups.filter(x => x.id == this.selectedItem.id)[0].subgroups.filter(y => y.id != val.id);

      groups.filter(x => x.id == this.selectedItem.id)[0].subgroups = subgroups;
      
      let where = {
        name: {
          like: 'Practice Team',
          options: "i"
        }
      };

      var data2 = {
        additionalProp1: {
          description: {
            text: this.category.additionalProp1.description ? this.category.additionalProp1.description.text : '',
          },
          icon: this.category.additionalProp1.icon,
          link: this.category.additionalProp1.link,
          groups: groups,
          related_information: updated_options
        },
      };

      api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, data2)
      .then(() => {
        let item = this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.filter(l => l.id == this.selectedItem.id)[0];
        item.subgroups = subgroups
        this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.filter(l => l.id == this.selectedItem.id)[0] = item;
        this.$store.commit('updateOldFormData', item)
        this.$store.commit('updateCurrentFormData', item)
        Swal.fire("Sub-Group Removed!", "Sub-Group Removed Successfully!", "success");

      }, (error) => {
        console.log(error);
      });
    },
    updateSubGroupFn(val) {
        var updated_options = this.page.tabs.filter(tab => tab.name == "Description")[0].form.related_information.options;

        var groups = this.category.additionalProp1.groups;

        groups.filter(x => x.id == this.selectedItem.id)[0].subgroups.push({
          id: uuidv4(),
          title: val,
          description: '',
        })

        let where = {
          name: {
            like: 'Practice Team',
            options: "i"
          }
        };

        var data2 = {
          additionalProp1: {
            description: {
              text: this.category.additionalProp1.description ? this.category.additionalProp1.description.text : '',
            },
            icon: this.category.additionalProp1.icon,
            link: this.category.additionalProp1.link,
            groups: groups,
            related_information: updated_options
          },
        };

        api.patch(`/api/cms/${this.currentCms.id}/categories?where=${JSON.stringify(where)}`, data2)
        .then(() => {
          this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options = groups;

          let item = this.page.tabs.filter(tab => tab.name == 'Groups')[0].side_panel.groups.options.filter(l => l.id == this.selectedItem.id)[0];
          this.$store.commit('updateOldFormData', item)
          this.$store.commit('updateCurrentFormData', item)

          Swal.fire("Sub-Group Added!", "Sub-Group Added Successfully!", "success");

        }, (error) => {
          console.log(error);
        });
    },
    selectedMemberLocation(val) {
      this.member_locations = val;
    },
    selectedMemberGroup(val) {
      this.member_group = val.title;
    },
    selectedMemberSubGroup(val) {
      if(val && val.title) {
        this.member_subgroup = val.title;
      }
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.topbar = this.page.tabs[0];
    // this.getLocations();
  }
};
</script>

<template>
  <Layout>
    <Heading :page="topbar" 
      :activeStatus="currentTopicActiveStatus" 
      @activateToggle="activateToggle"
      @created="create" 
      @deleted="deleted" 
      @form-submitted="submit"
    >
    </Heading>
    <FormBuilder :schema="page" :category="category" @selected-tab="selectedTabFn" @submit="submit" @selected-item="selectedItemFn" @selected-location="selectedLocationFn" @selected-group="selectedGroupFn" @selected-subgroup="selectedSubgroupFn"
    @add-group="updateGroupFn" @remove-group="updateGroupFn" @add-subgroup="updateSubGroupFn" @remove-subgroup="removeSubGroupFn"
    @selected-member-location="selectedMemberLocation" @selected-member-group="selectedMemberGroup" @selected-member-subgroup="selectedMemberSubGroup">

    </FormBuilder>
  </Layout>
</template>